// extracted by mini-css-extract-plugin
export default {"settings":"BusinessHomeSettings_settings__ciDO3"};